import { FelaCSS, colors } from '@bridebook/ui';

interface IStyles {
  wrapper: FelaCSS;
  iconWrapper: FelaCSS;
  title: FelaCSS;
  contentWrapper: FelaCSS;
  itemsWrapper: FelaCSS;
}

const styles = (): IStyles => ({
  wrapper: {
    flexDirection: 'row',
    paddingHorizontal: 2,
    paddingVertical: 3,
    border: `1px ${colors.indigoCrush} solid`,
    borderRadius: 12,
    backgroundColor: colors.white,
  },

  iconWrapper: {
    flexShrink: 0,
    alignItems: 'center',
    justifyContent: 'center',
    width: '40px',
    borderRightWidth: '1px',
    borderRightStyle: 'solid',
    borderRightColor: colors.space15,
  },
  title: {
    fontDefaultSemiBold: 14,
    lineHeight: 1,
    marginBottom: 2,
    desktopDesign: {
      marginBottom: 3,
    },
  },
  contentWrapper: {
    flexGrow: 1,
    paddingHorizontal: 4,
    paddingVertical: 2,
  },

  itemsWrapper: {
    gap: 8,
  },
});

export default styles;
